import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    createRes: null,
    getAllRes: null,
    getByIdRes: null,
    updateRes: null,
    getAlertsRes: null,
    adjustQuantityRes: null,
    usageHistoryRes: null,
    depletionSummaryRes: null,
};

const slice = createSlice({
    name: 'labReagent',
    initialState,
    reducers: {
        createLabReagentRequest: (state) => { state.loading = true; },
        createLabReagentSuccess: (state, action) => { state.loading = false; state.createRes = action.payload; },
        createLabReagentFailure: (state, action) => { state.loading = false; state.createRes = action.payload; },
        resetCreateLabReagent: (state) => { state.createRes = null; },

        getAllLabReagentRequest: (state) => { state.loading = true; },
        getAllLabReagentSuccess: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        getAllLabReagentFailure: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        resetGetAllLabReagent: (state) => { state.getAllRes = null; },

        getByIdLabReagentRequest: (state) => { state.loading = true; },
        getByIdLabReagentSuccess: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        getByIdLabReagentFailure: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        resetGetByIdLabReagent: (state) => { state.getByIdRes = null; },

        updateLabReagentRequest: (state) => { state.loading = true; },
        updateLabReagentSuccess: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        updateLabReagentFailure: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        resetUpdateLabReagent: (state) => { state.updateRes = null; },

        getReagentAlertsRequest: (state) => { state.loading = true; },
        getReagentAlertsSuccess: (state, action) => { state.loading = false; state.getAlertsRes = action.payload; },
        getReagentAlertsFailure: (state, action) => { state.loading = false; state.getAlertsRes = action.payload; },
        resetGetReagentAlerts: (state) => { state.getAlertsRes = null; },

        adjustReagentQuantityRequest: (state) => { state.loading = true; },
        adjustReagentQuantitySuccess: (state, action) => { state.loading = false; state.adjustQuantityRes = action.payload; },
        adjustReagentQuantityFailure: (state, action) => { state.loading = false; state.adjustQuantityRes = action.payload; },
        resetAdjustReagentQuantity: (state) => { state.adjustQuantityRes = null; },

        getUsageHistoryRequest: (state) => { state.loading = true; },
        getUsageHistorySuccess: (state, action) => { state.loading = false; state.usageHistoryRes = action.payload; },
        getUsageHistoryFailure: (state, action) => { state.loading = false; state.usageHistoryRes = action.payload; },
        resetGetUsageHistory: (state) => { state.usageHistoryRes = null; },

        getDepletionSummaryRequest: (state) => { state.loading = true; },
        getDepletionSummarySuccess: (state, action) => { state.loading = false; state.depletionSummaryRes = action.payload; },
        getDepletionSummaryFailure: (state, action) => { state.loading = false; state.depletionSummaryRes = action.payload; },
        resetGetDepletionSummary: (state) => { state.depletionSummaryRes = null; },
    }
});

export const {
    createLabReagentRequest, createLabReagentSuccess, createLabReagentFailure, resetCreateLabReagent,
    getAllLabReagentRequest, getAllLabReagentSuccess, getAllLabReagentFailure, resetGetAllLabReagent,
    getByIdLabReagentRequest, getByIdLabReagentSuccess, getByIdLabReagentFailure, resetGetByIdLabReagent,
    updateLabReagentRequest, updateLabReagentSuccess, updateLabReagentFailure, resetUpdateLabReagent,
    getReagentAlertsRequest, getReagentAlertsSuccess, getReagentAlertsFailure, resetGetReagentAlerts,
    adjustReagentQuantityRequest, adjustReagentQuantitySuccess, adjustReagentQuantityFailure, resetAdjustReagentQuantity,
    getUsageHistoryRequest, getUsageHistorySuccess, getUsageHistoryFailure, resetGetUsageHistory,
    getDepletionSummaryRequest, getDepletionSummarySuccess, getDepletionSummaryFailure, resetGetDepletionSummary,
} = slice.actions;

export default slice.reducer;
